<template>
    <stream-item-base 
        :line-type="lineType" 
        :line-colour="lineOrAccentColour" 
        class="stream-item" 
    >
        <div v-if="icon" class="stream-item-icon" :style="iconStyles">
            <span class="material-icons">{{ icon }}</span>
        </div>
        <div class="card" :style="itemStyles" @click="e => $emit('click', e)">
            <div v-if="menuOptions" class="stream-item-menu">
                <ui-icon-button ref="menuBtn" size="small" icon="arrow_drop_down" has-dropdown>
                    <ui-menu 
                        slot="dropdown"
                        :options="menuOptions"
                        @select="e => $emit('select', e)"
                        @close="$refs.menuBtn.closeDropdown()" />
                </ui-icon-button>
            </div>
            <slot />
        </div>
    </stream-item-base>
</template>

<style lang="scss">
    .stream-item {
        margin-top: 1rem;
        padding: 0;

        .stream-item-icon {
            position: absolute;
            left: -4rem;
            /* padding: .5rem; */
            //background: #fff;
            border-radius: 3px;
            //border-width: 2px; solid #ccc;
            width: 40px;
            height: 40px;
            padding-top: 8px;
            //color: #ccc;
            .material-icons { margin-left: .5rem; }
        }

        .stream-item-menu {
            position: absolute;
            right: 1rem;
            top: 1rem;

            .ui-icon-button--type-primary.ui-icon-button--color-default {
                background-color: rgba(0,0,0,.035);
            }
        }
    }
</style>

<script>
    import StreamItemBase from './StreamItemBase'
    import StreamItemSupport from './StreamItemSupport'

    export default {
        components: { StreamItemBase },
        mixins: [StreamItemSupport],
        props: {
            icon: {
                type: String,
            },
            accentColour: {
                type: String,
                default: '#ccc'
            },
            iconColour: {
                type: String,
                default: '#fff'
            },
            backgroundColour: {
                type: String,
                default: '#fff'
            },
            menuOptions: {
                type: Array
            }
        },
        computed: {
            lineOrAccentColour() {
                if (this.lineColour !== '#e0e0e0') {
                    return this.lineColour
                }

                return this.accentColour
            },
            iconStyles() {
                let styles = 'background: ' + this.accentColour + ';'
                
                if (this.iconColour) {
                    styles += 'color:' + this.iconColour + ';'
                }

                return styles
            },
            itemStyles() {
                if (this.backgroundColour !== '#fff') {
                    return 'background-color: ' + this.backgroundColour + ';'
                }
            }
        }
    }
</script>